export const DOCUMENT_TITLE: string = import.meta.env.VITE_DOCUMENT_TITLE;
export const GLOBAL_SERVICE: string = import.meta.env.VITE_GLOBAL_SERVICE;
export const PHONE_SERVICE: string = import.meta.env.VITE_PHONE_SERVICE;
export const SECRET_KEY: string = import.meta.env.VITE_SECRET_KEY;
export const LOGIN_BLOCKING_TIME: number = import.meta.env
  .VITE_LOGIN_BLOCKING_TIME;
export const LOGIN_MAX_ATTEMPTS: number = import.meta.env
  .VITE_LOGIN_MAX_ATTEMPTS;
export const IP_INFO_SERVICE: string = import.meta.env.VITE_IP_INFO_SERVICE;
export const DATA_EXCHANGE_TIMEOUT: number = import.meta.env
  .VITE_DATA_EXCHANGE_TIMEOUT;
export const TASKS_EXPIRE_SOON_THRESHOLD_IN_HOURS: number = import.meta.env
  .VITE_TASKS_EXPIRE_SOON_THRESHOLD_IN_HOURS;
export const NUMBER_OF_ALLOWED_DECIMALS: number = import.meta.env
  .VITE_NUMBER_OF_ALLOWED_DECIMALS;
export const MAX_FILE_SIZE_ALLOWED_IN_MB: number = import.meta.env
  .VITE_MAX_FILE_SIZE_ALLOWED_IN_MB;
export const PATIENT_DEFAULT_NAME: string = import.meta.env
  .VITE_PATIENT_DEFAULT_NAME;
export const PATIENT_DEFAULT_BIRTHDATE: string = import.meta.env
  .VITE_PATIENT_DEFAULT_BIRTHDATE;
export const PATIENT_DEFAULT_SECRET_ANSWER: string = import.meta.env
  .VITE_PATIENT_DEFAULT_SECRET_ANSWER;
export const PATIENT_DEFAULT_SECRET_QUESTION_ID: number = import.meta.env
  .VITE_PATIENT_DEFAULT_SECRET_QUESTION_ID;
export const MATOMO_URL: string = import.meta.env.VITE_MATOMO_URL;
export const MATOMO_SITE_ID: number = import.meta.env.VITE_MATOMO_SITE_ID;
export const SUPPORT_URL: string = import.meta.env.VITE_SUPPORT_URL;
export const SENTRY_DSN: string = import.meta.env.VITE_SENTRY_DSN;
export const ANDROID_PLAY_STORE_LINK: string = import.meta.env
  .VITE_ANDROID_PLAY_STORE_LINK;
export const IOS_APP_STORE_LINK: string = import.meta.env
  .VITE_IOS_APP_STORE_LINK;
export const PIN_LOGIN_MAX_ATTEMPTS: number = import.meta.env
  .VITE_PIN_LOGIN_MAX_ATTEMPTS;
export const WEARABLES_MAX_DAYS_FETCHING_INTERVAL: number =
  import.meta.env.VITE_WEARABLES_MAX_DAYS_FETCHING_INTERVAL ?? 14;
export const WEARABLES_MIN_HOURS_SYNC_INTERVAL: number =
  import.meta.env.VITE_WEARABLES_MIN_HOURS_SYNC_INTERVAL ?? 2;
export const HEALTHKIT_QUERY_LIMIT: number = import.meta.env
  .VITE_HEALTHKIT_QUERY_LIMIT;
export const PIN_DEACTIVATION_MAX_ATTEMPTS: number = import.meta.env
  .VITE_PIN_DEACTIVATION_MAX_ATTEMPTS;
export const WITHINGS_AUTH_URL: string = import.meta.env.VITE_WITHINGS_AUTH_URL;
export const WITHINGS_CLIENT_ID: string = import.meta.env
  .VITE_WITHINGS_CLIENT_ID;
export const OAUTH_REDIRECT_URL: string = import.meta.env
  .VITE_OAUTH_REDIRECT_URL;
export const SERVER_VERSION: string = import.meta.env.VITE_SERVER_VERSION;
export const MAX_FILE_SIZE_ALLOWED_IN_MB_IN_CHAT: number = import.meta.env
  .VITE_MAX_FILE_SIZE_ALLOWED_IN_MB_IN_CHAT;
export const BRANDING_VIDEO_LOOP_LENGTH_IN_MS: number = import.meta.env
  .VITE_BRANDING_VIDEO_LOOP_LENGTH_IN_MS;
export const PDF_VIEWER_API_KEY_NATIVE: string = import.meta.env
  .VITE_PDF_VIEWER_API_KEY_NATIVE;
export const PDF_VIEWER_API_KEY_PWA: string = import.meta.env
  .VITE_PDF_VIEWER_API_KEY_PWA;
